export const url = '/travel-file';
// export const Provider = 'TravelFile';
export const dbModel = 'TravelFile';

export const TABLE_NAME = 'travelfile';
